<template>
  <svg
    width="101"
    height="101"
    viewBox="0 0 101 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#9eu98xgara)">
      <mask
        id="6xb31ija3b"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="101"
        height="101"
      >
        <path d="M101 0H0v101h101V0z" fill="#fff" />
      </mask>
      <g mask="url(#6xb31ija3b)">
        <path
          opacity=".2"
          d="M0 56.812h101"
          stroke="#2B2B2D"
          stroke-width="9.378"
        />
        <path
          d="M50.5 1.578c21.911 0 39.452 18.222 39.453 40.423v35.224c0 12.135-9.602 22.196-21.72 22.197-11.856 0-22.467-9.8-22.467-22.197V45.338H34.969c-1.68 0-2.523-2.034-1.335-3.222l14.864-14.865a2.831 2.831 0 0 1 4.003 0l14.865 14.865c1.188 1.188.345 3.222-1.336 3.222H55.234v31.887c0 6.892 6.092 12.728 13 12.728 6.643 0 12.25-5.575 12.25-12.728V42.001c0-17.22-13.547-30.954-29.984-30.954S20.516 24.78 20.516 42v10.077h-9.47V42.001C11.049 19.8 28.59 1.578 50.5 1.578z"
          fill="#2B2B2D"
        />
      </g>
    </g>
    <defs>
      <clipPath id="9eu98xgara">
        <path
          fill="#fff"
          transform="scale(1.00966)"
          d="M0 0h100.034v100.034H0z"
        />
      </clipPath>
    </defs>
  </svg>
</template>
